import { graphqlFetch } from '@pylot-data/graphqlFetch'
import type { MutationResetPasswordArgs } from '@pylot-data/fwrdschema'
import { RESET_PASSWORD } from './graphql/passwordResetMutation'
import { useRouter } from 'next/router'
import { useAuthUI } from './AuthContext'

export const usePasswordReset = () => {
    const { locale } = useRouter()
    const { clearAuthCallback } = useAuthUI()

    return {
        passwordReset: async (params: MutationResetPasswordArgs) => {
            const createResult = await graphqlFetch<
                MutationResetPasswordArgs,
                { resetPassword: boolean }
            >({ query: RESET_PASSWORD, variables: params, locale })
            if (createResult.errors) throw createResult.errors

            clearAuthCallback('PASSWORD_RESET_VIEW')

            return { createResult }
        }
    }
}
